import Modal from './_modal.js';

export default class Wedding{
	constructor(){
		if(document.body.classList.contains("wedding")){
			this.initWeddingNavi();
		}
		if(document.body.classList.contains("wedding-top")){
			this.initWeddingTop();
		}
		if(document.body.classList.contains("wedding-article")){
			this.initWeddingArticle();
		}
		if(document.body.classList.contains("wedding-article") && document.body.classList.contains("wedding-fair")){
			this.initWeddingFairArticle();
		}
		if(document.body.classList.contains("wedding-gallery")){
			this.initWeddingGallery();
		}
		if(document.body.classList.contains("wedding-item")){
			this.initWeddingItem();
		}
	}
	initWeddingNavi(){
		const navi = document.querySelector(".wedding__navigation");
		const footer = document.querySelector(".wedding-top_photoservice") || document.querySelector(".footer");
		let startPositionGap = 0;
		let endPositionGap = 0;

		window.addEventListener("siteready", ()=>{
			ScrollTrigger.create({
				trigger: navi,
				start: "top+="+(window.rpx(window.currentContext=="pc" ? 0 : -55))+" top",
				endTrigger: footer,
				end: ()=>"top top+="+(window.rpx(window.currentContext=="pc" ? 100 : 110)),
				pin: true,
				pinSpacing: false,
				onEnter:     ()=>{ navi.classList.add("stick"); },
				onLeaveBack: ()=>{ navi.classList.remove("stick"); },
			});
		});

		if(window.currentContext=="sp"){
			const viewport = navi.querySelector(".wedding__navigation__viewport");
			const container = navi.querySelector(".wedding__navigation__container");
			const currentItem = navi.querySelector(".wedding__navigation__list__item.current");
			const navNext = navi.querySelector(".wedding__navigation__next");
			const navPrev = navi.querySelector(".wedding__navigation__prev");
			let navScrollAnim = null;
			let scrollLeft = 0;
			let isContinuousMove = false;
			let continuousMoveDelay = null;
			let continuousMoveAnimID = false;
			let initialPositionStableRequest = true;

			if(currentItem){
				let pos = 0;
				window.addEventListener("siteready", ()=>{
					const bound = currentItem.getBoundingClientRect();
					pos = parseInt(bound.left - window.innerWidth/2 + bound.width/2);
					setInitialScrollPosition();
				}, {once:true});	
				const setInitialScrollPosition = ()=>{
					viewport.scrollLeft = pos;
					if(initialPositionStableRequest) requestAnimationFrame(setInitialScrollPosition);
				}
				viewport.addEventListener("wheel", ()=>{ initialPositionStableRequest = false; }, {once: true});
				viewport.addEventListener("touchmove", ()=>{ initialPositionStableRequest = false; }, {once: true});
			}

			navPrev.addEventListener("click", ()=>{ moveNavCtl(false); return false; });
			navPrev.addEventListener("mousedown",  ()=>{ startContinuousMoveNavCtl(false); return false; });
			navPrev.addEventListener("mouseup",    ()=>{ endContinuousMoveNavCtl(); return false; });
			navPrev.addEventListener("mouseleave", ()=>{ endContinuousMoveNavCtl(); return false; });
			navNext.addEventListener("click", ()=>{ moveNavCtl(true); return false; });
			navNext.addEventListener("mousedown",  ()=>{ startContinuousMoveNavCtl(true); return false; });
			navNext.addEventListener("mouseup",    ()=>{ endContinuousMoveNavCtl(); return false; });
			navNext.addEventListener("mouseleave", ()=>{ endContinuousMoveNavCtl(); return false; });

			function moveNavCtl(direction){
				if(isContinuousMove === null){
					if(navScrollAnim) navScrollAnim.pause();
					const position = viewport.scrollLeft;
					const amount = direction ? 100 : -100;
					initialPositionStableRequest = false;
					navScrollAnim = gsap.to(viewport, { duration: 0.3, scrollTo: {y:0,x:position+amount}, ease: "power2" });
				}
			}
			function startContinuousMoveNavCtl(direction){
				continuousMoveDelay = setTimeout(()=>{
					isContinuousMove = direction;
					continuousMove();
				}, 200);
			}
			function continuousMove(){
				const amount = isContinuousMove ? 12 : -12;
				viewport.scrollLeft += amount;
				if(isContinuousMove !== null){
					continuousMoveAnimID = requestAnimationFrame(continuousMove);
				}
			}
			function endContinuousMoveNavCtl(){
				if(continuousMoveDelay) clearTimeout(continuousMoveDelay);
				cancelAnimationFrame(continuousMoveAnimID);
				isContinuousMove = null;
			}
			const navCtlBtnHandler = ()=>{
				scrollLeft = viewport.scrollLeft;
				if(viewport.offsetWidth < viewport.scrollWidth){
					navNext.classList.add("active");
				}else{
					navNext.classList.remove("active");
					endContinuousMoveNavCtl();
				}
				if(scrollLeft > 0){
					navPrev.classList.add("active");
				}else{
					navPrev.classList.remove("active");
					endContinuousMoveNavCtl();
				}
				if(scrollLeft >= viewport.scrollWidth - viewport.offsetWidth - 1){
					navNext.classList.remove("active");
					endContinuousMoveNavCtl();
				}
			}
			viewport.addEventListener("scroll", navCtlBtnHandler);
			window.addEventListener("resize", navCtlBtnHandler);
			navCtlBtnHandler();
		}
	}
	initWeddingTop(){
		// const gallerySection = document.querySelectorAll(".wedding-top__party");
		// gallerySection.forEach(section=>{
		// 	const titleset = section.querySelector(".kudryashevtitleset");
		// 	ScrollTrigger.create({
		// 		trigger: titleset,
		// 		start: ()=>"top top+="+rpx(100),
		// 		endTrigger: section,
		// 		end: ()=>"bottom bottom",
		// 		pin: true,
		// 		pinSpacing: true,
		// 		markers: true
		// 	});
		// });

		const feeds = document.querySelectorAll(".wedding-top__feeds .columnhalf__section");
		feeds.forEach(feed=>{
			const body = feed.querySelector(".columnhalf__section__body");
			const items = body.querySelectorAll(".wedding-top__feeds__list__item");
			items.forEach(item=>{
				if(window.currentContext=="pc"){
					item.addEventListener("mouseenter", ()=>{
						body.setAttribute("data-position", item.dataset.num);
					});
				}else{
					ScrollTrigger.create({
						trigger: item,
						start: "top 75%",
						end: "bottom 75%",
						onEnter: ()=>{
							body.setAttribute("data-position", item.dataset.num);
						},
						onEnterBack: ()=>{
							body.setAttribute("data-position", item.dataset.num);
						}
					});
				}
			});
		});

		const faq = document.querySelectorAll(".faq");
		const faqitems = document.querySelectorAll(".faq__item");
		faq.forEach(container=>{
			const navilinks = container.querySelectorAll(".faq__navigation button");
			navilinks.forEach(link=>{
				link.addEventListener("click", ()=>{
					faqitems.forEach(item=>{
						if(item.classList.contains("open")){
							const aBody = item.querySelector(".faq__item__a");
							aBody.style.height = "0px";
							item.classList.remove("open");
							item.classList.remove("transitioning");
						}
						item.classList.remove("close");
					});
					container.setAttribute("data-current", link.getAttribute("data-name"));
					window.globalScroller.scrollTo("#faq");
					return false;
				}, false);
			});
		});
		faqitems.forEach(item=>{
			const qLabel = item.querySelector(".faq__item__q");
			const aBody = item.querySelector(".faq__item__a");
			const aContainer = item.querySelector(".faq__item__a__inner");
			qLabel.addEventListener("click", ()=>{
				const itemTransitionEnd = ()=>{
					if(item.classList.contains("open")){
						aBody.style.height = "auto";
					}
					item.classList.remove("transitioning");
					if(window.smoothscroller) window.smoothscroller.refresh();	
					window.ScrollTrigger.refresh();
				}
				if(item.classList.contains("open")){
					item.classList.remove("open");
					item.classList.add("close");
					aBody.style.height = (aContainer.offsetHeight)+"px";
					item.classList.add("transitioning");
					aBody.removeEventListener("transitionend", itemTransitionEnd);
					requestAnimationFrame(()=>{requestAnimationFrame(()=>{
						aBody.style.height = "0px";
						aBody.addEventListener("transitionend", itemTransitionEnd, {once: true});
					})});
				}else{
					item.classList.remove("close");
					item.classList.add("open");
					aBody.style.height = "0px";
					item.classList.add("transitioning");
					aBody.removeEventListener("transitionend", itemTransitionEnd);
					requestAnimationFrame(()=>{requestAnimationFrame(()=>{
						aBody.style.height = (aContainer.offsetHeight)+"px";
						aBody.addEventListener("transitionend", itemTransitionEnd, {once: true});
					})});
				}
			}, false);
		});
	}
	initWeddingArticle(){
		if(window.currentContext == "pc"){
			const labelbanner = document.querySelector(".wedding-article__labelbanner");
			const main = document.querySelector(".wedding-article__main");
			if(labelbanner && main){
				ScrollTrigger.create({
					trigger: labelbanner,
					start: "top-="+rpx(100+30)+" top",
					endTrigger: main,
					end: ()=>"bottom+="+(window.innerHeight - labelbanner.offsetHeight - rpx(100+30))+" bottom",
					pin: true,
					pinSpacing: false
				});
			}
		}
	}
	initWeddingFairArticle(){
		const reservation = document.body.querySelector(".wedding-fair__reservation");
		const label_year = reservation.querySelector(".labelbanner__primary .year");
		const label_date = reservation.querySelector(".labelbanner__primary .date");
		const label_day = reservation.querySelector(".labelbanner__primary .day");
		const calender_day_btn = reservation.querySelectorAll("a.calender__days__day");

		const switchReservationDate = (date, day, daytype, holiday)=>{
			const datetexts = date.split("-");
			label_year.innerText = datetexts[0];
			label_date.innerText = datetexts[1]+"/"+datetexts[2];
			label_day.innerHTML = "<span>"+day+"</span>";
			label_day.classList.remove("weekday", "saturday", "holiday");
			if(holiday == "true"){
				label_day.classList.add("holiday");
				label_day.innerHTML = "<span>"+day+"・祝</span>";
			}else{
				label_day.classList.add(daytype);
			}

			const currentDayBtn = reservation.querySelector("a.calender__days__day.current");
			const targetDayBtn = reservation.querySelector("a.calender__days__day[data-date='"+date+"']");
			const currentReservationBlock = reservation.querySelector(".wedding-fair__reservation__day.current");
			const targetReservationBlock = reservation.querySelector(".wedding-fair__reservation__day[data-date='"+date+"']");
			if(currentDayBtn) currentDayBtn.classList.remove("current");
			if(targetDayBtn) targetDayBtn.classList.add("current");
			if(currentReservationBlock) currentReservationBlock.classList.remove("current");
			if(targetReservationBlock) targetReservationBlock.classList.add("current");
			if(window.smoothscroller) window.smoothscroller.refresh();
		}

		calender_day_btn.forEach(btn=>{
			btn.addEventListener("click", (e)=>{
				if(!btn.classList.contains("current")){
					switchReservationDate(btn.dataset.date, btn.dataset.day, btn.dataset.daytype, btn.dataset.holiday);
				}
				e.preventDefault();
				e.stopPropagation();
				return false;
			}, false);
		});
	}
	initWeddingGallery(){
		const modal = new Modal();
		const sections = document.querySelectorAll(".wedding-gallery__main__section");
		sections.forEach(section=>{
			let sectionBound = section.getBoundingClientRect();
			const container = section.querySelector(".wedding-gallery__pager__container");
			const pages = section.querySelectorAll(".wedding-gallery__pager__page");
			const slides = [];
			pages.forEach((pager,i)=>{
				pager.setAttribute("data-num", i);
				slides.push({
					thumb: pager.querySelector("img").getAttribute("src"),
					src: pager.getAttribute("href")
				});
				pager.addEventListener("click", (e)=>{ openModal(e,i); }, false)
			});
			const dummyAfter = document.createElement("div");
			const dummyBefore = document.createElement("div");
			for(let i=0; i<pages.length; i++){
				const cloneA = pages.item(i).cloneNode(true);
				const cloneB = pages.item(i).cloneNode(true);
				dummyAfter.append(cloneA);
				dummyBefore.append(cloneB);
				cloneA.addEventListener("click", (e)=>{ openModal(e,i); }, false)
				cloneB.addEventListener("click", (e)=>{ openModal(e,i); }, false)
			}
			dummyAfter.classList.add("dummyAfter");
			dummyBefore.classList.add("dummyBefore");
			container.append(dummyAfter);
			container.append(dummyBefore);


			const minSpeed = 0.05;
			const maxSpeed = 0.3;
			let groupWidth = (window.currentContext=="pc" ? (60+10) : (55+5)) * slides.length / 10; //rem換算
			let targetSpeed = minSpeed;
			let speed = minSpeed;
			let posX = 0;
			let direction = true;
			let isMouseOn = false;
			let request = null;
			const update = ()=>{
				if(isMouseOn){
					speed += (targetSpeed - speed)/10;
				}else{
					speed += (targetSpeed - speed)/10;
				}
				posX += speed;
				if(posX >= groupWidth) posX = posX-groupWidth;
				if(posX <= groupWidth*-1) posX = posX+groupWidth;
				
				container.style.transform = "translateX("+(posX*-1)+"rem)";
				request = requestAnimationFrame(update);
			}
			const pause = () =>{
				if(request) cancelAnimationFrame(request);
			}
			update();

			const resizeHandler = ()=>{
				groupWidth = (window.currentContext=="pc" ? (60+10) : (55+5)) * slides.length / 10; //rem換算
				container.style.width = groupWidth+"rem"
			}
			const openModal = (e,i)=>{
				e.preventDefault();
				e.stopPropagation();
				sectionBound = section.getBoundingClientRect();
				modal.openModal(slides, i);
				return false;
			}
			window.addEventListener("resize", resizeHandler, false);
			resizeHandler();

			if(window.isTouch){
				let dragStartX = 0;
				let dragStartY = 0;
				let dragLastX = 0;
				let dragLastY = 0;
				let dragLastX2 = 0;
				let dragLastY2 = 0;
				let dragActive = null;
				let dragging = false;
				let startPos = 0;
				let endPos = 0;
				function dragStart(x,y,e){
					if(window.currentContext == "pc") return;
					pause();
					dragStartX = x;
					dragStartY = y;
					dragLastX = x;
					dragLastY = y;
					dragLastX2 = x;
					dragLastY2 = y;
					dragActive = null;
					dragging = true;
					startPos = posX;
					container.classList.add("dragging");
				}
				function dragMove(x,y,e){
					if(window.currentContext == "pc") return;
					if(!dragging) return;
					if(dragActive === null){
						if(Math.abs(dragStartX-x) > Math.abs(dragStartY-y)){
							dragActive = true;
						}else{
							dragActive = false;
						}
						if(!window.isTouch) dragActive = true;
					}
					if(dragActive !== true) return false;
					endPos = ((x-dragStartX)/-10)+posX;
					if(x-dragStartX > 0){
						if(endPos >= groupWidth) endPos = endPos-groupWidth;
					}else{
						if(endPos <= groupWidth*-1) endPos = endPos+groupWidth;
					}
					container.style.transform = "translateX("+(endPos*-1)+"rem)";
					dragLastX2 = dragLastX;
					dragLastY2 = dragLastY;
					dragLastX = x;
					dragLastY = y;
					e.preventDefault();
				}
				function dragEnd(x,y,e){
					if(window.currentContext == "pc") return;
					if(!dragging) return;
					container.classList.remove("dragging");
					dragging = false;
					if(dragActive) posX = endPos;
					speed = (dragLastX2-dragLastX)/8.5;
					update();
				}
				container.addEventListener("touchstart", (e)=>{
					if(e.changedTouches){
						dragStart(e.changedTouches[0].pageX,e.changedTouches[0].pageY,e);
					}else{
						dragStart(e.pageX,e.pageY,e);
					}
				}, false);
				container.addEventListener("touchmove", (e)=>{
					if(e.changedTouches){
						dragMove(e.changedTouches[0].pageX,e.changedTouches[0].pageY,e);
					}else{
						dragMove(e.pageX,e.pageY,e);
					}
					if(dragActive){
						return false;
					}
				}, false);
				container.addEventListener("touchleave", (e)=>{
					if(e.changedTouches){
						dragEnd(e.changedTouches[0].pageX,e.changedTouches[0].pageY,e);
					}else{
						dragEnd(e.pageX,e.pageY,e);
					}
				}, false);
				container.addEventListener("touchend", (e)=>{
					if(e.changedTouches){
						dragEnd(e.changedTouches[0].pageX,e.changedTouches[0].pageY,e);
					}else{
						dragEnd(e.pageX,e.pageY,e);
					}
				}, false);
			}else{
				const mousemove = (e)=>{
					const pos = Math.max(0, Math.min(section.offsetWidth, e.clientX - sectionBound.x));
					const amount = (pos-section.offsetWidth/2)/(section.offsetWidth/2);
					direction = amount>0;
					targetSpeed = maxSpeed*amount*Math.abs(Math.pow(amount,2));
					isMouseOn = true;
				}
				const mouseleave = ()=>{
					if(direction){
						targetSpeed = minSpeed;
					}else{
						targetSpeed = minSpeed*-1;
					}
					isMouseOn = false;
				}
				container.addEventListener("mousemove", mousemove, false);
				container.addEventListener("mouseleave", mouseleave, false);
			}
		});

		const covers = document.querySelectorAll(".wedding-gallery__cover");
		covers.forEach(cover=>{
			const img = cover.querySelector(".wedding-gallery__cover__img");
			gsap.fromTo(img, {
				yPercent: 0,
			},{ 
				yPercent: 20,
				ease: "none",
				scrollTrigger: { 
					trigger: cover,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					invalidateOnRefresh: true,
				}
			});
		});
	}
	initWeddingItem(){
		const covers = document.querySelectorAll(".wedding-item__cover");
		covers.forEach(cover=>{
			const img = cover.querySelector(".wedding-item__cover__img");
			gsap.fromTo(img, {
				yPercent: 0,
			},{ 
				yPercent: 20,
				ease: "none",
				scrollTrigger: { 
					trigger: cover,
					start: "top bottom",
					end: "bottom top",
					scrub: true,
					invalidateOnRefresh: true,
				}
			});
		});
	}
}